import { create } from 'zustand'
import type { HistoryMeta } from './types'

type HistoryMetaState = HistoryMeta

export const useHistoryMetaStore = create<HistoryMetaState>(() => ({
  canUndo: false,
  canRedo: false,
}))

export function syncHistoryMeta(pastCount: number, futureCount: number): void {
  useHistoryMetaStore.setState({
    canUndo: pastCount > 0,
    canRedo: futureCount > 0,
  })
}
